import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  productTypeContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
  },
  textHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: theme.palette.labraCheckbox.main,
  },
  sectionHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  sectionText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    width: '100%',
  },
  sectionHeadingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  companyDetailsContainer: {
    display: 'flex',
    gap: theme.spacing(3),
    width: '100%',
  },
  inputWidth: {
    width: '50%',
  },
  resellerNameAutocompleteContainer: {
    width: '50%',
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      minHeight: theme.spacing(5.5),
      height: theme.spacing(5.5),
    },
    '& .MuiOutlinedInput-root > fieldset > legend': {
      fontSize: theme.typography.caption.fontSize,
      letterSpacing: '0.5px',
    },
    '& .MuiOutlinedInput-root legend > span': {
      paddingLeft: 0,
      paddingRight: theme.spacing(0.2),
      width: 'auto',
    },
    '& .MuiFormControl-root .MuiInputLabel-root.MuiInputLabel-formControl': {
      fontSize: theme.typography.body2.fontSize,
      lineHeight: theme.typography.body2.lineHeight,
      letterSpacing: '0.25px',
      top: theme.spacing(-0.5),
    },
    '& .MuiFormControl-root .MuiInputLabel-root.MuiInputLabel-outlined.MuiInputLabel-formControl:not(.MuiInputLabel-shrink)':
      {
        transform: `translate(${theme.spacing(1.75)}, ${theme.spacing(2)}) scale(1)`,
        transformOrigin: 'top left',
      },
    '& .MuiFormControl-root .MuiInputLabel-root.MuiInputLabel-outlined.MuiInputLabel-formControl.MuiInputLabel-shrink':
      {
        fontSize: theme.typography.caption.fontSize,
        transform: `translate(${theme.spacing(1.5)}, ${theme.spacing(-1.125)}) scale(1)`,
        top: 0,
        lineHeight: theme.typography.caption.lineHeight,
        padding: `0 ${theme.spacing(-2)}`,
        backgroundColor: theme.palette.text.white,
      },
  },
}))
